export default "__VITE_ASSET__DOC0hiGB__"